import { render } from "./Sync.vue?vue&type=template&id=30b09f2c"
import script from "./Sync.vue?vue&type=script&lang=js"
export * from "./Sync.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__